import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { AttachmentViewerProps } from './AttachmentViewer.types';
import { AttachmentViewerContainer } from './AttachmentViewerContainer';
import { AttachmentViewerSkeleton } from './AttachmentViewerSkeleton';

export const LazySingleAttachmentViewer: FunctionComponent<
  AttachmentViewerProps
> = ({ onClose, attachmentId, cardId }) => {
  const SingleAttachmentViewer = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "single-attachment-viewer" */ './SingleAttachmentViewer'
      ),
    { namedImport: 'SingleAttachmentViewer', preload: false },
  );

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-web-eng',
        feature: 'Single Attachment Viewer',
      }}
    >
      <AttachmentViewerContainer onClose={onClose}>
        <ChunkLoadErrorBoundary fallback={null}>
          <Suspense fallback={<AttachmentViewerSkeleton />}>
            <SingleAttachmentViewer
              onClose={onClose}
              attachmentId={attachmentId}
              cardId={cardId}
            />
          </Suspense>
        </ChunkLoadErrorBoundary>
      </AttachmentViewerContainer>
    </ErrorBoundary>
  );
};
